import constants from 'constants/index'
import * as yup from 'yup'

const { EVIDENCE_FILE_TYPES, EVIDENCE_FILE_MIMES_TYPES } = constants.planAction

const schema = yup.object().shape({
  documentType: yup
    .string()
    .oneOf(['attachment', 'linkedDocument'], 'Selecione o tipo de documento')
    .required('Selecione o tipo de documento'),
  attachments: yup.mixed().fileUpload({
    sizeLimit: 30,
    unit: 'MB',
    types: EVIDENCE_FILE_TYPES,
    mimeTypes: EVIDENCE_FILE_MIMES_TYPES,
    required: { field: 'documentType', is: 'attachment' },
  }),
  privacyPolicyIds: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
      }),
    )
    .when('documentType', {
      is: 'linkedDocument',
      then: (schema) => schema.min(1, 'Selecione ao menos um documento'),
    }),
})

export default schema
